import Vue from 'vue';
import {Types} from 'mongoose';

type tBusEvent = 'update:events' | 'update:event.select' | 'update:event.unselect' | 'show:handoutEvent' | 'reload:event' | 'reload:handoutEvent';

interface TimetableBusInterface {
    $emit(event: 'reload:event' | 'close:info-dialog' | 'reload:handoutEvent'): void;
    /** Updates the selected event - can accept ObjectId or customId */
    $emit(event: 'update:event.select', id: Types.ObjectId | string): any;
    $emit(event: 'update:events', selectedCustomId?: string): any;
    $emit(event: tBusEvent, ...args: any): any;
    $on(event: 'close:info-dialog', callback: () => void): any;
    $on(event: 'update:event.select', callback: (id: Types.ObjectId | string) => void): any;
    $on(event: 'update:events', callback: (selectedCustomId?: string) => void): any;
    $on(event: tBusEvent | tBusEvent[], callback: (...args: any) => void): any;
    $off(event: string | string[], callback?: (...args: any) => void): any;
}

export const TimetableBus: TimetableBusInterface = new Vue();
